import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "q-pa-md text-dark"
}
const _hoisted_2 = { class: "" }
const _hoisted_3 = { class: "box-row items-center" }
const _hoisted_4 = {
  class: "header",
  style: {"min-width":"15px"}
}
const _hoisted_5 = { class: "content" }
const _hoisted_6 = { class: "q-mt-sm" }
const _hoisted_7 = { class: "box-row" }
const _hoisted_8 = { class: "header" }
const _hoisted_9 = { class: "content" }
const _hoisted_10 = { class: "text-body2" }
const _hoisted_11 = { class: "q-mt-sm" }
const _hoisted_12 = { class: "box-row" }
const _hoisted_13 = { class: "header" }
const _hoisted_14 = { class: "content" }
const _hoisted_15 = { class: "text-body2" }
const _hoisted_16 = { class: "q-mt-sm" }
const _hoisted_17 = { class: "box-row" }
const _hoisted_18 = { class: "header" }
const _hoisted_19 = { class: "content" }
const _hoisted_20 = ["innerHTML"]
const _hoisted_21 = { class: "q-mt-sm" }
const _hoisted_22 = { class: "box-row" }
const _hoisted_23 = { class: "header" }
const _hoisted_24 = { class: "content" }
const _hoisted_25 = { class: "text-body2" }
const _hoisted_26 = { key: 1 }
const _hoisted_27 = { class: "text-body3 q-pa-md" }

import { PropType, ref, computed, watch } from "vue";  
  import { useAuthStore } from "src/stores/auth-store";
  import { QCheckbox } from "quasar";
  import { LoanApplication } from "src/types/loan-application/index";

  
export default /*@__PURE__*/_defineComponent({
  __name: 'DealerTermsForm',
  props: {
    proposal: {
      type: Object as PropType<LoanApplication>,
      default: {
      } as LoanApplication
    },
    readonly: {
      type: Boolean,
      default: false
    }
  },
  setup(__props, { expose: __expose }) {

  const authStore = useAuthStore();

  const props = __props

  const fcaLabel = computed(() => `The customer is aware that both ${authStore.dealerName} and Car Finance 247 are authorised and regulated by the Financial Conduct Authority.`);
  const commissionLabel = computed(() => `The customer is aware that Car Finance 247 do not charge a fee for their service and that both ${authStore.dealerName} and Car Finance 247 will earn a commission but that it will not influence the interest rate they will pay in any way.`);
  const privacyLabel = computed(() => `The customer is aware that upon submission of this application their data will be processed in line with Car Finance 247's <a href='https://www.carfinance247.co.uk/terms-and-conditions' target='_blank'>Terms & Conditions</a> and their <a href='https://www.carfinance247.co.uk/privacy-policy' target='_blank'>Privacy Policy</a> and the customer has access to both of these.`);
  const consentLabel = computed(() => `The information in this application form has been gathered directly from the customer and is accurate to the best of my knowledge and I have received consent to submit this application.`);

  const accepted = ref(false);
  const validated = ref(false);
  function validate() {
    validated.value = true;
    
    return props.proposal.hasDealerAgreedTermsAndConditions;
  }
  __expose({ validate });

  watch(() => accepted.value, () => {
    props.proposal.hasDealerAgreedTermsAndConditions = accepted.value
    if (props.proposal.hasDealerAgreedTermsAndConditions) {
      props.proposal.dealerAgreedTermsAndConditionsDate = new Date();
    }
  })
  

return (_ctx: any,_cache: any) => {
  const _component_q_icon = _resolveComponent("q-icon")!

  return (!__props.readonly)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_unref(QCheckbox), {
                modelValue: accepted.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((accepted).value = $event)),
                class: "text-body2",
                rules: [(val) => !!val || 'Required']
              }, null, 8, ["modelValue", "rules"])
            ]),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("span", {
                class: _normalizeClass(["text-subtitle2", !accepted.value && validated.value ? 'text-negative' : ''])
              }, "By ticking this box I confirm:", 2)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createVNode(_component_q_icon, {
                name: "mdi-circle-small",
                size: "lg"
              })
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("span", _hoisted_10, _toDisplayString(fcaLabel.value), 1)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              _createVNode(_component_q_icon, {
                name: "mdi-circle-small",
                size: "lg"
              })
            ]),
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("span", _hoisted_15, _toDisplayString(commissionLabel.value), 1)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("div", _hoisted_18, [
              _createVNode(_component_q_icon, {
                name: "mdi-circle-small",
                size: "lg"
              })
            ]),
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("span", {
                class: "text-body2",
                innerHTML: privacyLabel.value
              }, null, 8, _hoisted_20)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_21, [
          _createElementVNode("div", _hoisted_22, [
            _createElementVNode("div", _hoisted_23, [
              _createVNode(_component_q_icon, {
                name: "mdi-circle-small",
                size: "lg"
              })
            ]),
            _createElementVNode("div", _hoisted_24, [
              _createElementVNode("span", _hoisted_25, _toDisplayString(consentLabel.value), 1)
            ])
          ])
        ])
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_26, [
        _createElementVNode("div", _hoisted_27, _toDisplayString(__props.proposal.createdBy) + " accepted Terms and Conditions on " + _toDisplayString(new Date(__props.proposal.dealerAgreedTermsAndConditionsDate).toLocaleString()), 1)
      ]))
}
}

})